import ReactGA from 'react-ga';

const trackingId = "G-Q91SR0Q9DB";
ReactGA.initialize(trackingId);

export const trackPageView = (page) => {
  ReactGA.set({ page });
  ReactGA.pageview(page);
};
